export default {
  data() {
    return {
      formData: {},
    };
  },
  props: {
    uForm: {
      type: String,
      default: '',
    },
  },
  beforeMount() {
    this.setUmbracoRouteAndToken();
  },
  methods: {
    setUmbracoRouteAndToken() {
      if (!this.uForm) {
        console.warn('No Umbraco form found. Is the u-form property set?');
      } else {
        const doc = new DOMParser().parseFromString(this.uForm, 'text/html');
        const ufprt = doc.querySelector('input[type=hidden][name=ufprt]').value;
        const requestVerificationToken = doc.querySelector('input[type=hidden][name=__RequestVerificationToken]').value;
        this.formData.ufprt = ufprt;
        this.formData.__RequestVerificationToken = requestVerificationToken;
      }
    },
  },
};
